const CERTIFICATE_ROBOTS =
  'noindex, nofollow, noarchive, nosnippet, noimageindex, noopensearch, noodp, notranslate, noyield, noerror, nohreflang';

// 사이트 미노출 강의(EJEDU-194)는 링크로만 들어오게 하려고 색인을 막는다.
// 이 태그는 앱이 실행된 뒤에 붙는다. 구글·네이버 수집기는 Edge 함수가 만든 HTML 을 받아 앱을 실행하지 않으므로
// 그쪽 차단은 Edge 함수가 따로 해야 한다(관제 저장소 docs/exec-plans/tech-debt-tracker.md 의 D-112)
export const getRobotsContent = (pathname, noindex) => {
  if (pathname.includes('/certificate')) return CERTIFICATE_ROBOTS;
  return noindex ? 'noindex' : null;
};
